import React, { Fragment, Component } from "react"
import Async from "react-select"
import leftArrowImage from "../../../assets/images/left-arrow.png"
import Picky from "react-picky"

//components
import ImageTopLeft from "../../ImageTopLeft"
import Field from "../../Common/Field/Field"
import Button from "../../Buttons/Button"
import FileUpload from "../../FileUpload/FileUpload"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

export default class SubModule extends Component {
  state = {
    action: "",
    _id: "",
    disabled: this.props.disabled
  }

  render() {
    const {
      data,
      index,
      meetingNote,
      disabled,
      styleList,
      garmentTypeOption,
      imageTypeOption,
      meetingNoteID,
      options
    } = this.props

    const mocksOption = [
      {
        value: "Embellishment",
        label: "Embellishment"
      },
      {
        value: "Embroidery",
        label: "Embroidery"
      },
      {
        value: "Wash",
        label: "Wash"
      },
      {
        value: "Construction",
        label: "Construction"
      }
    ]

    return (
      <form>
        <div className="col-md-12 ">
          <div className="row" style={{ paddingBottom: "2%" }}>
            <div
              className="col-md-12 product-form no-padding meeting-notes"
              style={{ marginTop: "3%" }}
            >
              <div class="col-md-12 px-0 py-2 position-top-stick">
                <div className="col-md-4 nopadding text-left">
                  <span
                    className="p-2 cursor-hover"
                    onClick={() => this.props.backToList()}
                  >
                    <img width={"20px"} src={leftArrowImage} />
                  </span>
                </div>
                <div className="col-md-4 nopadding text-center" />
                <div className="col-md-4">
                  {!this.state.disabled && (
                    <ButtonIcon
                      buttonType={"remove"}
                      addRemoveFunc={() => this.props.removeSketch(index)}
                    />
                  )}
                </div>
              </div>
              <div className="col-md-12 multiple-mm-con no-padding">
                <div className="col-md-3" style={{ padding: "35px" }}>
                  <div>{`${this.props.meetingNote.MNId} - ${index + 1}`}</div>
                  <ImageTopLeft
                    image={
                      data.sketchImage == undefined ? "" : data.sketchImage
                    }
                    // removeImage={this.props.removeMNoteImage}
                    noRemove={true}
                    fileUpload={files => this.props.changeImg(files, index)}
                    disabled={this.state.disabled}
                    type="type2"
                  />

                  {/* <div className="form-group">
                    <label for="imageDescription">Comments:</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      cols="50"
                      id="imageComment"
                      placeholder=""
                      name="imageDescription"
                      value={data.imageDescription}
                      onChange={e =>
                        this.props.updateValue(
                          e.target.name,
                          e.target.value,
                          index
                        )
                      }
                    />
                  </div> */}

                  <br />

                  {(data.sampleStyle === "Existing Sample" ||
                    data.sampleStyle === "IB" ||
                    data.sampleStyle === "Order") && (
                      <Fragment>
                        <div className="col-md-8 step-one no-padding">
                          <div className="form-group">
                            <label for="magnumStyleNumer">
                              Magnum Style Number
                          </label>
                            <div className="custom-async-select">
                              <Async
                                name="magnumStyleId"
                                value={data.styleReferenceId}
                                onInputChange={value =>
                                  this.props.getStyleInfo(value)
                                }
                                onChange={value =>
                                  this.props.changeStyleInfo(value, index)
                                }
                                onSelectResetsInput={false}
                                placeholder="Find Style"
                                options={styleList}
                                disabled={this.state.disabled}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 step-one no-padding">
                          <div className="form-group">
                            <label for="magnumStyleName">Magnum Style Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder=""
                              name="styleName"
                              value={data.magnumStyleName}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </Fragment>
                    )}
                  <div className="col-md-12 step-one no-padding">
                    <div className="form-group">
                      <label for="customerRefNumber">Customer Ref No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="customerRefNumber"
                        // value={options
                        //   .map(x => {
                        //     return x._id === meetingNote.customer &&
                        //       x.departmentId ===
                        //         meetingNote.customerDepartmentId
                        //       ? `${x.customerName}-${x.departmentName}`
                        //       : null
                        //   })
                        //   .filter(Boolean)}
                        value={
                          data.customerRefNumber ? data.customerRefNumber : null
                        }
                        disabled={this.state.disabled}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="col-md-12 mul-check check-padding">
                    <div className="form-group col-md-2 no-padding">
                      <label for="city">Sample Style</label>
                    </div>
                    <p className="radio-inline">
                      <input
                        name={`newSample${index}`}
                        type="radio"
                        className="filled-in hide-all"
                        id={`newSample${index}`}
                        checked={data.sampleStyle === "New Sample" && true}
                        disabled={this.state.disabled}
                      />
                      <label
                        for={`newSample${index}`}
                        onClick={() => this.props.selectNewSample(index)}
                      >
                        New Sample
                      </label>
                    </p>
                    <p className="radio-inline">
                      <input
                        name={`newSample${index}`}
                        type="radio"
                        className="filled-in hide-all"
                        id={`existingSample${index}`}
                        checked={
                          (data.sampleStyle === "Existing Sample" ||
                            data.sampleStyle === "IB" ||
                            data.sampleStyle === "Order") &&
                          true
                        }
                        disabled={this.state.disabled}
                        onClick={() => this.props.selectExistingSample(index)}
                      />
                      <label for={`existingSample${index}`}>
                        Existing Sample
                      </label>
                    </p>
                    {(data.sampleStyle === "Existing Sample" ||
                      data.sampleStyle === "IB" ||
                      data.sampleStyle === "Order") && (
                        <Fragment>
                          <p className="radio-inline">
                            <input
                              name={`IB${index}`}
                              type="radio"
                              className="filled-in ib"
                              id={`IB${index}`}
                              checked={data.sampleStyle === "IB" && true}
                              onClick={() => this.props.selectNewIB(index)}
                              disabled={this.state.disabled}
                            />
                            <label for={`IB${index}`}>IB</label>
                          </p>
                          <p className="radio-inline">
                            <input
                              name={`IB${index}`}
                              type="radio"
                              className="filled-in order"
                              id={`order${index}`}
                              checked={data.sampleStyle === "Order" && true}
                              onClick={() => this.props.selectNewOrder(index)}
                              disabled={this.state.disabled}
                            />
                            <label for={`order${index}`}>Order</label>
                          </p>
                        </Fragment>
                      )}
                    <p className="radio-inline justify-content-end">
                      <Field
                        isFormGroup={true}
                        inputType="date"
                        inputName="sampleDeadline"
                        value={data.sampleDeadline ? data.sampleDeadline : new Date()}
                        index={index}
                        label={"Sample Deadline"}
                        onChange={this.props.updateValue}
                        disabled={this.props.disabled}
                      />
                    </p>

                  </div>
                  <div className="col-md-3 step-one">
                    <div className="form-group">
                      <label for="phone">Block / Historic Ref No.</label>
                      <input
                        type="text"
                        className="form-control"
                        name="blockRefNumber"
                        index={index}
                        placeholder=""
                        value={data.blockRefNumber}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-3 step-one">
                    <div className="form-group">
                      <label for="phone">Block / Historic Ref from</label>
                      <select
                        className="form-control"
                        name="blockRefFrom"
                        index={index}
                        value={data.blockRefFrom}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      >
                        <option value="select">Select</option>
                        <option value="Customer Block">Customer Block</option>
                        <option value="Magnum Ref Number">
                          Magnum Ref Number
                        </option>
                        <option value="Development Sample">
                          Development Sample
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3 step-one">
                    <div className="form-group">
                      <label for="phone">Sketch</label>
                      <select
                        className="form-control"
                        name="sketch"
                        value={data.sketch}
                        index={index}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      >
                        <option value="Select">Select</option>
                        <option value="Designer Tech Park">
                          Designer Tech Park
                        </option>
                        <option value="Buyer Tech Park">Buyer Tech Park</option>
                        <option value="Image">Image</option>
                      </select>
                    </div>
                  </div>
                  {/* <div className="col-md-3 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="date"
                      inputName="sampleDeadline"
                      value={data.sampleDeadline ? data.sampleDeadline : new Date()}
                      index={index}
                      label={"Sample Deadline"}
                      onChange={this.props.updateValue}
                      disabled={this.props.disabled}
                    />
                  </div> */}
                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">fabric</label>
                      <textarea
                        className="form-control"
                        name="fabric"
                        rows="4"
                        index={index}
                        cols="50"
                        placeholder=""
                        value={data.fabric}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">Quality</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        cols="50"
                        index={index}
                        placeholder=""
                        name="quality"
                        value={data.quality}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">Artwork / Color Ref</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        cols="50"
                        index={index}
                        placeholder=""
                        name="artwork"
                        value={data.artwork}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">trim</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        cols="50"
                        index={index}
                        placeholder=""
                        name="trim"
                        value={data.trim}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 step-one">
                    <div className="form-group">
                      <label for="phone">Fit Comments / Styling Changes</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        cols="50"
                        index={index}
                        placeholder=""
                        name="fitComments"
                        value={data.fitComments}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label for="phone">wash</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      cols="50"
                      index={index}
                      placeholder=""
                      name="wash"
                      value={data.wash}
                      onChange={e =>
                        this.props.updateValue(
                          e.target.name,
                          e.target.value,
                          index
                        )
                      }
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div className="col-md-6">
                    <label for="phone">print</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      cols="50"
                      index={index}
                      placeholder=""
                      name="print"
                      value={data.print}
                      onChange={e =>
                        this.props.updateValue(
                          e.target.name,
                          e.target.value,
                          index
                        )
                      }
                      disabled={this.state.disabled}
                    />
                    {/* <Field
                  isFormGroup={true}
                  inputType="text"
                  inputName="print"
                  value={data.print}
                  label="print"
                  index={index}
                  onChange={this.props._handleInputChangeForSketch}
                  disabled={disabled}
                /> */}
                  </div>
                  <div className="col-md-6">
                    <label for="phone">Embroidery</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      cols="50"
                      index={index}
                      placeholder=""
                      name="embroidery"
                      value={data.embroidery}
                      onChange={e =>
                        this.props.updateValue(
                          e.target.name,
                          e.target.value,
                          index
                        )
                      }
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">Action / Remarks</label>
                      <textarea
                        type="text"
                        className="form-control"
                        rows="4"
                        cols="50"
                        index={index}
                        placeholder=""
                        name="remarks"
                        value={data.remarks}
                        onChange={e =>
                          this.props.updateValue(
                            e.target.name,
                            e.target.value,
                            index
                          )
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 step-one">
                    <div className="form-group">
                      <label for="phone">garment Type</label>
                      <div className="custom-async-select">
                        <Async
                          name="garmentType"
                          value={data.garmentType}
                          index={index}
                          onInputChange={this.props.getGarmentInfo}
                          onChange={value =>
                            this.props.changeGarmentType(value.value, index)
                          }
                          placeholder="Find GarmentType"
                          options={garmentTypeOption || []}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 mul-check">
                    <div className="form-group">
                      <label for="city">Pending Item from</label>
                      {/* <ReactMultiSelectCheckboxes
                        value={data.pendingItem}
                        onChange={val => this.props.changePendingItem(val, index)}
                        options={[
                          {
                            value: "Magnum",
                            label: "Magnum"
                          },
                          {
                            value: "Udare",
                            label: "Udare"
                          },
                          {
                            value: "Buyer",
                            label: "Buyer"
                          }
                        ]}
                      /> */}
                      <Picky
                        value={data.pendingItem}
                        options={[
                          {
                            value: "Magnum",
                            label: "Magnum"
                          },
                          {
                            value: "Udare",
                            label: "Udare"
                          },
                          {
                            value: "Buyer",
                            label: "Buyer"
                          }
                        ]}
                        onChange={val =>
                          this.props.changePendingItem(val, index)
                        }
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        includeFilter={true}
                        dropdownHeight={300}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-3 pl-0 mul-check">
                    <div className="form-group">
                      <label for="city">Mocks</label>
                      <Picky
                        value={data.mocks}
                        options={mocksOption}
                        onChange={value => this.props.changeMocks(value, index)}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        includeFilter={true}
                        dropdownHeight={300}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="form-group" />
                  </div>

                  {(data.sampleStyle === "IB" ||
                    data.sampleStyle === "Order") &&
                    data.IB !== undefined &&
                    Array.isArray(data.IB) &&
                    data.IB.length > 0 &&
                    data.IB.map((ib, indexVal) => (
                      <div className="ib-select ib order">
                        <div className="col-md-12 multiple-mm-con no-padding">
                          <div className="col-md-3 step-one">
                            {indexVal === 0 && <label for="ib">IB/Order</label>}
                            <div className="form-group">
                              {indexVal === 0 && <label>price</label>}
                              {indexVal !== 0 && <br />}
                              <input
                                type="number"
                                min="0"
                                index={index}
                                className="form-control"
                                placeholder=""
                                value={ib.price}
                                name="price"
                                onChange={e =>
                                  this.props.ibValueChange(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    indexVal,
                                    "IB"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 step-one">
                            <br />
                            <div className="form-group">
                              <label className={indexVal !== 0 ? "d-none" : ""}>
                                Qty
                              </label>
                              <input
                                type="number"
                                min="0"
                                index={index}
                                className="form-control"
                                placeholder=""
                                value={ib.qty}
                                name="qty"
                                onChange={e =>
                                  this.props.ibValueChange(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    indexVal,
                                    "IB"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 step-one">
                            <div className="form-group">
                              <br />
                              <label className={indexVal !== 0 ? "d-none" : ""}>
                                Date
                              </label>
                              <Field
                                isFormGroup={false}
                                inputType="date"
                                inputName="ibDate"
                                value={ib.ibDate ? ib.ibDate : ""}
                                index={index}
                                onChange={(name, value) =>
                                  this.props.ibValueChange(
                                    name,
                                    value,
                                    index,
                                    indexVal,
                                    "IB"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </div>
                          </div>
                          <div className="col-md-2 step-one">
                            {!this.state.disabled && (
                              <Fragment>
                                <a
                                  style={
                                    indexVal === 0
                                      ? { display: "block" }
                                      : { display: "none" }
                                  }
                                  className="btn-floating btn-small waves-effect waves-light green addIB_Shipment"
                                  onClick={e =>
                                    this.props.changeIBSize(
                                      index,
                                      indexVal,
                                      "add"
                                    )
                                  }
                                >
                                  <i className="material-icons">add</i>
                                </a>
                                <a
                                  style={
                                    indexVal !== 0
                                      ? { display: "block" }
                                      : { display: "none" }
                                  }
                                  className="btn-floating btn-small waves-effect waves-light red remove-box"
                                  id="remove-box"
                                  onClick={e =>
                                    this.props.changeIBSize(
                                      index,
                                      indexVal,
                                      "remove"
                                    )
                                  }
                                >
                                  <i className="material-icons">clear</i>
                                </a>
                              </Fragment>
                            )}
                          </div>
                        </div>

                        <div className="row nopadding" />
                      </div>
                    ))}
                  {(data.sampleStyle === "Order" ||
                    data.sampleStyle === "IB") &&
                    data.shipmentDetails !== undefined &&
                    Array.isArray(data.shipmentDetails) &&
                    data.shipmentDetails.length > 0 &&
                    data.shipmentDetails.map((shipment, indexVal) => (
                      <div className="ib-select ib order">
                        <div className="col-md-12 multiple-mm-con no-padding">
                          <div className="col-md-5 step-one">
                            <div className="form-group">
                              {indexVal === 0 && (
                                <span>
                                  <label for="ib">ShipmentDetail</label>
                                  <label>quantity</label>
                                </span>
                              )}
                              {/* {indexVal !== 0 && <br />}                                                             */}
                              <input
                                type="number"
                                min="0"
                                className="form-control"
                                placeholder=""
                                value={shipment.quantity}
                                name="quantity"
                                onChange={e =>
                                  this.props.shippingValueChange(
                                    e.target.name,
                                    e.target.value,
                                    indexVal,
                                    index
                                  )
                                }
                                diabled={this.state.disabled}
                              />
                            </div>
                          </div>
                          <div className="col-md-5 step-one">
                            <div className="form-group">
                              {indexVal === 0 && (
                                <span>
                                  <br />
                                  <label>Date</label>
                                </span>
                              )}
                              <Field
                                isFormGroup={false}
                                inputType="date"
                                inputName="date"
                                value={shipment.date ? shipment.date : ""}
                                index={index}
                                onChange={(name, value) =>
                                  this.props.shippingValueChange(
                                    name,
                                    value,
                                    indexVal,
                                    index
                                  )
                                }
                                diabled={this.state.disabled}
                              />
                              <br />
                            </div>
                          </div>
                          <div className="col-md-2 step-one">
                            {!this.state.disabled && (
                              <Fragment>
                                <a
                                  style={
                                    indexVal === 0
                                      ? { display: "block" }
                                      : { display: "none" }
                                  }
                                  className="btn-floating btn-small waves-effect waves-light green addIB_Shipment"
                                  onClick={e =>
                                    this.props.changeShippingSize(
                                      index,
                                      indexVal,
                                      "add"
                                    )
                                  }
                                >
                                  <i className="material-icons">add</i>
                                </a>
                                <a
                                  style={
                                    indexVal !== 0
                                      ? { display: "block" }
                                      : { display: "none" }
                                  }
                                  className="btn-floating btn-small waves-effect waves-light red  remove-box"
                                  id="remove-box"
                                  onClick={e =>
                                    this.props.changeShippingSize(
                                      index,
                                      indexVal,
                                      "remove"
                                    )
                                  }
                                >
                                  <i className="material-icons">clear</i>
                                </a>
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div class="col-md-12 px-5 mt-3">
                <FileUpload
                  Heading="Upload Images"
                  moduleName={"meetingnote"}
                  getRefImages={this.props.getRefImages}
                  disabled={disabled}
                  index={index}
                  uploadedDocs={
                    meetingNote.sketches[index].refImages.length > 0
                      ? meetingNote.sketches[index].refImages
                      : null
                  }
                  imageTypeOption={imageTypeOption ? imageTypeOption : []}
                />
              </div>
              <div className="col-md-12 px-5 mt-3">
                <div className="form-group">
                  <label for="additionalInfo" className="active">
                    Additional Info
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    rows="4"
                    index={index}
                    cols="50"
                    name="additionalInfo"
                    value={data.additionalInfo}
                    onChange={e =>
                      this.props.updateValue(
                        e.target.name,
                        e.target.value,
                        index
                      )
                    }
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              <div className="col-md-12">
                {/* <FileUpload
            /> */}
                <div className="col-md-12 text-center">
                  {!this.state.disabled && (
                    <Fragment>
                      <button
                        className="primary"
                        onClick={e => {
                          this.props.saveMeetingNote(e)
                          // setTimeout(() => this.props.history.goBack(), 700)
                        }}
                      >
                        Save
                      </button>{" "}
                      <Button
                        buttonName="back"
                        onClick={() => this.props.backToList()}
                      />
                      <Button
                        buttonName="Generate Style"
                        onClick={this.props.generateStyle}
                      />
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/MeetingNote/SubModule/index.js